import { clamp01, easeOutCubic } from "~/lib/web/ease";

/** Narrow no-break space, so a figure cannot break across two lines. */
const GROUP_SPACE = " ";

/** Fixed rather than the reader's locale: the comma grouping is part of the design. */
export const withCommas = (value: number): string =>
  value.toLocaleString("en-US");

export const withGroupSpaces = (value: number): string =>
  String(Math.round(value)).replace(/\B(?=(\d{3})+$)/g, GROUP_SPACE);

/**
 * Counts from `from` to `to` with an ease-out. The returned callback cancels a
 * run in flight.
 */
export const countUp = (
  from: number,
  to: number,
  durationMs: number,
  write: (value: number) => void,
): (() => void) => {
  let started = 0;
  let frame = 0;
  const step = (now: number): void => {
    if (!started) started = now;
    const p = clamp01((now - started) / durationMs);
    write(from + (to - from) * easeOutCubic(p));
    frame = p < 1 ? requestAnimationFrame(step) : 0;
  };
  frame = requestAnimationFrame(step);
  return () => {
    cancelAnimationFrame(frame);
    frame = 0;
  };
};
